// CMS data layer for announcements.
// `cms.announcements` schema: (id, organization_id, title, body_md, published_at, created_at, updated_at)
// published_at IS NULL → draft; NOT NULL → published.

import { supabase, isSupabaseConfigured } from "../supabase";

const SCHEMA = "cms";

function table() {
  if (!isSupabaseConfigured) throw new Error("Requires live Supabase");
  return supabase.schema(SCHEMA).from("announcements");
}

export async function listAnnouncements({ search, status } = {}) {
  let q = table()
    .select("*")
    .order("updated_at", { ascending: false });
  if (status === "draft") q = q.is("published_at", null);
  if (status === "published") q = q.not("published_at", "is", null);
  if (search) q = q.ilike("title", `%${search}%`);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function getAnnouncement(id) {
  const { data, error } = await table()
    .select("*")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data || null;
}

export async function createAnnouncement({ organizationId, title, bodyMd, publish }) {
  const { data, error } = await table()
    .insert({
      organization_id: organizationId,
      title,
      body_md: bodyMd || null,
      published_at: publish ? new Date().toISOString() : null,
    })
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

export async function updateAnnouncement(id, patch) {
  const { data, error } = await table()
    .update(patch)
    .eq("id", id)
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

export async function publishAnnouncement(id) {
  return updateAnnouncement(id, { published_at: new Date().toISOString() });
}

export async function unpublishAnnouncement(id) {
  return updateAnnouncement(id, { published_at: null });
}

export async function deleteAnnouncement(id) {
  const { data, error } = await table()
    .delete()
    .eq("id", id)
    .select("id");
  if (error) throw error;
  if (!data || data.length === 0) throw new Error("Could not delete announcement");
}

export function announcementStatus(row) {
  return row?.published_at ? "published" : "draft";
}
